import { CREATE_PRODUCT, GET_PRODUCTS } from './ApiConstants';
import api from './ApiHandler';

export const getProductsList = async ({
  page,
  limit,
  entityId,
}: {
  page: number;
  limit: number;
  entityId: any;
}) => {
  return await api.get(GET_PRODUCTS, {
    params: { page, limit, entityId },
  });
};

interface CreateProductPayloads {
  productName: string;
  categoryId: string;
  subcategoryId: string;
  description: string;
  price: number;
  productType: string;
  ingredients: [
    { ingredient: string; unit: string; quantity: number; price: number },
    { ingredient: string; unit: string; quantity: number; price: number },
  ];
  nutritions: [
    { nutrition: string; unit: string; quantity: number; percent: number },
  ];
  productSKU: string;
  status: string;
}

export const createProduct = async (payload: CreateProductPayloads) => {
  return await api.post(CREATE_PRODUCT, { ...payload });
};

export const getProductsByPage = async (payload: any) => {
  return await api.get(GET_PRODUCTS, { params: payload });
};

// export const getProduct = async ({ id }: { id: string }) => {
//   return await api.get(GET_PRODUCT, { params: { id } });
// };
